module.exports = __webpack_public_path__ + "static/neon@2x-6a36156bf25bd2d7a2e1ce095f41870f.png";